import React from "react";

/**
 * Returns the flag asset path for a rugby team or country name.
 * Handles both team names (e.g. "New Zealand", "All Blacks") and
 * country names (e.g. "Argentina", "Japan").
 */
export const rugbyFlagPath = (name?: string): string => {
  const t = (name || "").toLowerCase();
  if (t.includes("england")) return "/assets/Flag_of_England.svg";
  if (t.includes("scotland")) return "/assets/Flag_of_Scotland.svg";
  if (t.includes("wales")) return "/assets/Flag_of_Wales.svg";
  if (t.includes("northern ireland")) return "/assets/Flag_of_Northern_Ireland.svg";
  if (t.includes("ireland")) return "/assets/Flag_of_Ireland.svg";
  if (t.includes("france")) return "/assets/Flag_of_France.svg";
  if (t.includes("italy")) return "/assets/Flag_of_Italy.svg";
  if (t.includes("new zealand") || t.includes("all blacks")) return "/assets/Flag_of_New_Zealand.svg";
  if (t.includes("australia") || t.includes("wallabies")) return "/assets/Flag_of_Australia.svg";
  if (t.includes("south africa") || t.includes("springboks")) return "/assets/Flag_of_South_Africa.svg";
  if (t.includes("argentina") || t.includes("pumas")) return "/assets/Flag_of_Argentina.svg";
  if (t.includes("japan")) return "/assets/Flag_of_Japan.svg";
  return "/assets/uk.svg";
};

interface FlagImgProps {
  name?: string;
  size?: number;
  label?: string;
  style?: React.CSSProperties;
}

/** Small inline flag badge (image only, no text). */
export const FlagImg: React.FC<FlagImgProps> = ({ name, size = 22, label, style }) => {
  const h = size;
  const w = Math.round(h * 1.6);
  return (
    <img
      src={rugbyFlagPath(name)}
      alt={label || name || "flag"}
      width={w}
      height={h}
      style={{ display: "block", borderRadius: 6, objectFit: "cover", ...style }}
    />
  );
};
